var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var $9Dess = parcelRequire("9Dess");
var $1appp = parcelRequire("1appp");

var $2eEP7 = parcelRequire("2eEP7");

var $5oSvy = parcelRequire("5oSvy");

var $F5GHR = parcelRequire("F5GHR");

var $kkp0U = parcelRequire("kkp0U");

var $T3ldG = parcelRequire("T3ldG");
const $8cd78d81c294292d$export$d641c58d62c1c984 = (paymentCode)=>{
    return (0, $T3ldG.default).get(`${"https://myheronapim.azure-api.net/guest/checkPaymentCode"}?PaymentCode=${paymentCode}`, {
        headers: {
            "Ocp-Apim-Subscription-Key": "7b89cc0699d94c299fa1631a1b0c2e39"
        }
    });
};



var $6g79T = parcelRequire("6g79T");

var $gLG3I = parcelRequire("gLG3I");

var $2DGCP = parcelRequire("2DGCP");

var $7SNu6 = parcelRequire("7SNu6");

var $kWQ6K = parcelRequire("kWQ6K");
$1appp.init({
    dsn: "https://388eda95ee7d478a8484b269881c5a5e@o324589.ingest.sentry.io/5853247",
    release: undefined,
    environment: "production",
    ignoreErrors: [
        "Request aborted",
        "Error: Network Error",
        "TypeError: Cancelled",
        "TypeError: Failed to fetch",
        "timeout exceeded"
    ]
});
function $b30b3ed8e389ca1b$var$invokePayment() {
    (0, $kkp0U.toggleButtonLoader)(true);
    const inputsArr = [].slice.call((0, $kkp0U.getInputFields)());
    (0, $kkp0U.removeErrors)(inputsArr);
    const formData = inputsArr.reduce((accumulator, currentValue)=>{
        return {
            ...accumulator,
            [currentValue.id]: currentValue.value
        };
    }, {});
    if ($b30b3ed8e389ca1b$var$isGuest === false && $b30b3ed8e389ca1b$var$commodity && !(0, $7SNu6.isNullOrWhitespace)($b30b3ed8e389ca1b$var$meterId)) {
        $b30b3ed8e389ca1b$var$pay(formData);
        return;
    }
    $b30b3ed8e389ca1b$var$meterId = null;
    $b30b3ed8e389ca1b$var$commodity = null;
    (0, $8cd78d81c294292d$export$d641c58d62c1c984)(formData.PaymentCode).then((res)=>{
        if (res.data.Result === true) {
            $b30b3ed8e389ca1b$var$commodity = res.data.Commodity;
            $b30b3ed8e389ca1b$var$pay(formData);
            return;
        }
        (0, $kkp0U.addErrorToFields)([
            "PaymentCode"
        ]);
    }).catch((error)=>{
        (0, $kkp0U.toggleButtonLoader)(false);
        if (error.response?.data?.ResponseCode === 404) {
            (0, $kkp0U.addErrorToFields)([
                "PaymentCode"
            ]);
            return;
        }
        (0, $kkp0U.showErrorBox)();
    });
}
function $b30b3ed8e389ca1b$var$pay(formData) {
    const errorFields = (0, $F5GHR.validateForm)(formData);
    if (errorFields.length > 0) {
        (0, $kkp0U.addErrorToFields)(errorFields);
        (0, $kkp0U.toggleButtonLoader)(false);
        return;
    }
    const jsonFormData = JSON.stringify({
        ...formData,
        token: $b30b3ed8e389ca1b$var$token,
        accountId: $b30b3ed8e389ca1b$var$accountId,
        createdAt: new Date()
    });
    try {
        localStorage.setItem("myheron_payment_form_data;", jsonFormData);
    } catch (error) {
        const errorMessage = error?.message || "";
        /* catching to avoid QuotaExceeded Errors from being logged. 
    /* not setting data to local storage does not break the functionality of the page. user will just have to reenter the data on the form */ if (errorMessage.toLowerCase().indexOf("quota") === -1) $9Dess.withScope((scope)=>{
            $9Dess.captureException(error);
        });
    }
    const amount = (0, $F5GHR.getAmount)(formData.Amount);
    const paymentCode = document.querySelector("#PaymentCode").value;
    const trackUnconfirmedPayment = $b30b3ed8e389ca1b$var$isEna === false;
    // {cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}
    const parameters = [
        formData?.CardholderName || " ",
        amount,
        paymentCode,
        $b30b3ed8e389ca1b$var$meterId,
        $b30b3ed8e389ca1b$var$commodity,
        trackUnconfirmedPayment,
        $b30b3ed8e389ca1b$var$invoiceNo
    ];
    try {
        if (paymentCode?.length !== 25) $9Dess.withScope((scope)=>{
            scope.setExtras({
                parameters: parameters,
                parametersDefinition: "{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}"
            });
            scope.setLevel("info");
            $9Dess.captureMessage("Payment page - Wrong Payment Code length in parameters");
        });
    } catch (error) {}
    try {
        if (paymentCode?.trim()?.length !== 25) $9Dess.withScope((scope)=>{
            scope.setExtras({
                parameters: parameters,
                parametersDefinition: "{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}"
            });
            scope.setLevel("info");
            $9Dess.captureMessage("Payment page - Wrong Payment Code length in parameters (TRIMMED)");
        });
    } catch (error) {}
    const data = {
        CurrencyCode: 978,
        BillAddrCity: formData.BillAddrCity,
        BillAddrCountry: formData.BillAddrCountry,
        BillAddrLine1: formData.BillAddrLine1,
        BillAddrPostCode: formData.BillAddrPostCode,
        BillAddrState: formData.BillAddrState,
        Email: formData.Email,
        HomePhone: (0, $F5GHR.getPhone)(formData.HomePhone),
        Amount: amount,
        Parameters: parameters.join("|")
    };
    if (!$b30b3ed8e389ca1b$var$commodity) {
        $9Dess.withScope((scope)=>{
            scope.setExtras({
                data: JSON.stringify($b30b3ed8e389ca1b$var$_receivedData)
            });
            scope.setLevel("info");
            $9Dess.captureMessage("Payment invocation with empty commodity prevented");
        });
        (0, $kkp0U.showErrorBox)();
        (0, $kkp0U.toggleButtonLoader)(false);
        return;
    }
    (0, $6g79T.getTicket)(data).then((res)=>{
        const response = res.data;
        const merchantRef = response ? response.MerchantReference : null;
        (0, $F5GHR.populatePaymentKeys)(merchantRef, $b30b3ed8e389ca1b$var$commodity);
        const lang = (0, $2eEP7.getLanguage)();
        document.querySelector("input[name=ParamBackLink]").value = `lang=${lang}`;
        document.querySelector("input[name=LanguageCode]").value = lang === "el" ? "el-GR" : "en-US";
        (0, $kkp0U.showDelayAndRemoveBankRedirectionDialog)($b30b3ed8e389ca1b$var$submitForm);
        return;
    }).catch((error)=>{
        (0, $kkp0U.showErrorBox)();
    }).finally(()=>{
        (0, $kkp0U.toggleButtonLoader)(false);
    });
}
function $b30b3ed8e389ca1b$var$submitForm() {
    document.querySelector("#redirection_form").submit();
}
function $b30b3ed8e389ca1b$var$getBillDetails(token, accountId) {
    if (!token || token.length === 0) return;
    const storedData = (0, $kWQ6K.isWebStorageSupported)() && localStorage.getItem("myheron_payment_form_data;");
    if (storedData) {
        const _formData = JSON.parse(storedData);
        if (_formData.token && _formData.token === token && (!_formData.accountId || _formData.accountId === accountId) && //use cached data for 15'
        (new Date() - new Date(_formData.createdAt)) / 1000 / 60 <= 15) {
            (0, $kkp0U.fillForm)(_formData);
            (0, $kkp0U.enableInputs)();
            document.getElementById("terms").checked = false;
            return;
        }
        localStorage.removeItem("myheron_payment_form_data;");
    }
    (0, $kkp0U.togglePageLoader)(true);
    // if you want to use the test endpoint use
    // "api/my-bill";
    (0, $gLG3I.getUserDetails)(token, accountId).then((res)=>{
        // Fill the form
        (0, $kkp0U.fillForm)(res.data);
    }).catch((error)=>{
        if (error.response?.status === 401) // no need to log 401 unauthorized errors
        return;
    }).then(()=>{
        (0, $kkp0U.togglePageLoader)(false);
        (0, $kkp0U.enableInputs)();
    });
}
// Wait for client to send paymentCode: ‘’, amount: '', token: '', guest:
let $b30b3ed8e389ca1b$var$isEna = false;
let $b30b3ed8e389ca1b$var$isGuest = true;
let $b30b3ed8e389ca1b$var$token = null;
let $b30b3ed8e389ca1b$var$accountId = null;
let $b30b3ed8e389ca1b$var$meterId = null;
let $b30b3ed8e389ca1b$var$commodity = null;
let $b30b3ed8e389ca1b$var$isSettlement = false;
let $b30b3ed8e389ca1b$var$invoiceNo = null;
let $b30b3ed8e389ca1b$var$_receivedData = null;
window.addEventListener("message", (event)=>{
    if ((0, $7SNu6.isAllowedUrl)(event.origin)) {
        $b30b3ed8e389ca1b$var$_receivedData = event.data;
        if (typeof event.data.guest !== "undefined" || typeof event.data.token !== "undefined") {
            $b30b3ed8e389ca1b$var$isGuest = event.data.guest === true;
            $b30b3ed8e389ca1b$var$token = event.data.token;
            $b30b3ed8e389ca1b$var$accountId = event.data.accountId;
            $b30b3ed8e389ca1b$var$isEna = event.data.isEna === true;
            $b30b3ed8e389ca1b$var$isSettlement = event.data.fixedAmount === true;
            if ($b30b3ed8e389ca1b$var$isGuest === true) {
                document.querySelector("#PaymentCode").disabled = false;
                document.querySelector("#Amount").disabled = false;
                (0, $kkp0U.enableInputs)();
                (0, $kkp0U.togglePageLoader)(false);
                $b30b3ed8e389ca1b$var$meterId = null;
                $b30b3ed8e389ca1b$var$commodity = null;
            } else if ($b30b3ed8e389ca1b$var$token) {
                if (event.data.paymentCode) {
                    try {
                        if (event.data.paymentCode?.length !== 25) $9Dess.withScope((scope)=>{
                            scope.setExtras({
                                postData: JSON.stringify(event.data)
                            });
                            scope.setLevel("info");
                            $9Dess.captureMessage("Payment page - Wrong Payment Code received");
                        });
                    } catch (error) {}
                    document.querySelector("#PaymentCode").value = event.data.paymentCode;
                    document.querySelector("#PaymentCode").disabled = true;
                } else document.querySelector("#PaymentCode").disabled = false;
                if (event.data.amount) document.querySelector("#Amount").value = (0, $F5GHR.getAmountWithCurrency)(event.data.amount);
                if ($b30b3ed8e389ca1b$var$isEna) document.querySelector("#ena_info").style.display = "block";
                if (event.data.meterId) $b30b3ed8e389ca1b$var$meterId = event.data.meterId;
                if (event.data.invoiceNo) $b30b3ed8e389ca1b$var$invoiceNo = event.data.invoiceNo;
                document.querySelector("#Amount").disabled = event.data.fixedAmount === true;
                if (event.data.commodity) $b30b3ed8e389ca1b$var$commodity = `${event.data.commodity}` === `${(0, $2DGCP.commodities).gas}` ? (0, $2DGCP.commodities).gas : (0, $2DGCP.commodities).energy;
                else $9Dess.withScope((scope)=>{
                    scope.setExtras({
                        postData: JSON.stringify($b30b3ed8e389ca1b$var$_receivedData)
                    });
                    scope.setLevel("info");
                    $9Dess.captureMessage("Payment page - non guest payment with empty commodity");
                });
                $b30b3ed8e389ca1b$var$getBillDetails($b30b3ed8e389ca1b$var$token, $b30b3ed8e389ca1b$var$accountId);
            }
            const lang = (0, $2eEP7.getLanguage)();
            document.querySelector('label[for="Amount"]').innerHTML = $b30b3ed8e389ca1b$var$isEna ? (0, $2eEP7.langs)[lang].participation : (0, $2eEP7.langs)[lang].debtAmount;
        }
    }
}, false);
window.addEventListener("load", function() {
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach;
    (0, $2eEP7.setLanguage)();
    (0, $5oSvy.populateStatesSelect)();
    document.querySelectorAll('input[type="text"]').forEach((x)=>{
        (0, $kkp0U.handleErrorClassOnChange)(x);
    });
    // Notify the client that the form has loaded
    window.parent.postMessage("Payment gateway initialised.", "*");
    if (window.callbackHandler) window.callbackHandler.completedSuccessfully("Payment gateway initialised.");
    try {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.completedSuccessfully) window.webkit.messageHandlers.completedSuccessfully.postMessage("Payment gateway initialised.");
    } catch (error) {
        $9Dess.withScope(function(scope) {
            scope.setExtras({
                snippet: "window.webkit"
            });
            $9Dess.captureException(error);
        });
    }
    document.querySelector(".close-icon").addEventListener("click", (0, $kkp0U.removeErrorBox));
    const checkbox = document.querySelector("input[type=checkbox]");
    const submit = document.querySelector("button[type=submit]");
    checkbox.addEventListener("change", function() {
        submit.disabled = !this.checked;
    });
    const form = document.getElementById("form");
    form.addEventListener("submit", function(event) {
        event.preventDefault();
        $b30b3ed8e389ca1b$var$invokePayment();
    });
});


//# sourceMappingURL=index.1a2b9c9a.js.map
